import React from 'react';

function NoMatch() {
  return (
    <div>
      <h1>Page not found</h1>
    </div>
  );
}

export default NoMatch;
